import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../components/CustomModal/CustomModal";
import useStyles from "./styles";
import { FC } from "react";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { useDeleteUserAdmin as useDelete } from "../../../api/user";
import toast from "react-hot-toast";

type props = {
  open: boolean;
  userGenericInitial: TUserGeneric;
  onCancel?: () => void;
  onClose?: () => void;
  initUserGeneric?: () => void;
};

export const ModalDeleteUserGeneric: FC<props> = ({
  open,
  userGenericInitial,
  onCancel,
  onClose,
  initUserGeneric,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { mutate: deleteUserGeneric, isPending } = useDelete(
    onClose,
    initUserGeneric
  );

  const onConfirm = () => {
    /*
     * `id` only - never `userID` as a fallback.
     *
     * `userID ?? id` looked defensive but was the bug: it PREFERRED the field
     * the API was filling from `company_user.id`, so this dialog deleted by
     * membership id. Two id spaces must never be tried in sequence - a
     * fallback that resolves to the wrong entity is worse than no value at
     * all, because it produces a successful request against someone else.
     */
    const userId = userGenericInitial?.id;
    if (Number.isInteger(userId) && userId > 0) {
      deleteUserGeneric(userId);
    } else {
      toast.error(t("user.invalidUser", "Invalid user"));
    }
  };

  return (
    <CustomModal
      open={open}
      onCancel={onCancel}
      title={""}
      onClose={onClose}
      isConfirmation
      textConfirmation={t("login.newPassword", "Validate")}
      loadingConfirmation={isPending}
      onConfirm={onConfirm}
    >
      <div className={classes.textModalContainer}>
        <CustomTypography
          text={t("userGeneric.delete", {
            name: userGenericInitial?.lastname,
            firstname: userGenericInitial?.firstname,
          })}
          variant="default"
        />
      </div>
    </CustomModal>
  );
};
